"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
var i18next_1 = require("i18next");
var react_i18next_1 = require("react-i18next");
var i18next_formatters_1 = require("@equiem/i18next-formatters");
var union_1 = __importDefault(require("lodash/union"));
var merge_1 = __importDefault(require("lodash/merge"));
var config_1 = require("./config");
var backend_1 = require("./backend");
var debugLanguages_1 = require("./debugLanguages");
var localeDetector_1 = require("./localeDetector");
function initialize(_a) {
    var _b;
    var _c = _a.instance, instance = _c === void 0 ? (0, i18next_1.createInstance)() : _c, _d = _a.defaultNamespace, defaultNS = _d === void 0 ? config_1.defaultNamespace : _d, _e = _a.availableNamespaces, ns = _e === void 0 ? [defaultNS] : _e, _f = _a.languages, languages = _f === void 0 ? {} : _f, localePreferenceScope = _a.localePreferenceScope, gqlRequester = _a.gqlRequester;
    var resources = (0, merge_1.default)({}, config_1.errorLanguages, config_1.equiemOneLanguages, languages);
    var debugResources = (0, debugLanguages_1.makeDebugLanguages)(resources, config_1.defaultLocale);
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (((_b = resources[config_1.defaultLocale]) === null || _b === void 0 ? void 0 : _b[defaultNS]) == null) {
        throw new Error("i18n missing default locale");
    }
    var supportedLanguages = __spreadArray(__spreadArray([], Object.keys(debugResources), true), Object.keys(resources), true);
    instance
        .use(new backend_1.Backend(__assign(__assign({}, debugResources), resources)))
        .use(new localeDetector_1.LocaleDetector(gqlRequester, localePreferenceScope, supportedLanguages))
        .use(react_i18next_1.initReactI18next);
    var isInitialized = false;
    instance.on("initialized", function () {
        isInitialized = true;
    });
    var initializedPromise = instance
        .init({
        fallbackLng: config_1.defaultLocale,
        ns: (0, union_1.default)(ns, [config_1.serverMessagesNamespace]),
        defaultNS: defaultNS,
        interpolation: {
            escapeValue: false,
            skipOnVariables: false,
        },
        react: {
            useSuspense: false,
        },
    })
        .catch(function (e) { return console.error("i18n initialization error:", e); });
    (0, i18next_formatters_1.applyFormatters)(instance);
    return {
        instance: instance,
        initializedPromise: initializedPromise,
        isInitialized: function () { return isInitialized; },
    };
}
exports.initialize = initialize;
